module.exports = __webpack_public_path__ + "images/emoji/ok_woman.402b911610750fd873e0.png";